import React from "react";

const Automation = () => {
    return (
        <>
            This is Automation Page
        </>
    );
};

export default Automation;
